const configuredApiBaseURL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const defaultApiBaseURL = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:9000';

const config = {
  // A URL base da API é definida pela variável de ambiente para produção,
  // ou aponta para localhost para desenvolvimento.
  apiBaseURL: configuredApiBaseURL || defaultApiBaseURL,
  apiCep: 'https://viacep.com.br/ws/',
  get apiUrl() { return `${this.apiBaseURL}/api`; }, // URL completa da API derivada da base
};
 
export default config;
